import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import InputMask from 'react-input-mask';
import moment from 'moment';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function FetchModal({
  fetchRecord,
  createSelect,
  fetching,
  syncing,
  formData,
  setFormData,
  id,
  approveTransaction,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);
  const [accountData, setAccountData] = useState('');

  const years = _.range(1970, +moment().format('YYYY') + 1).sort(
    (a, b) => b - a
  );

  const formatPeriod = (data) => {
    let val = '';
    switch (data) {
      case 0:
        val = '1st Quarter';
        break;
      case 1:
        val = '1st Quarter';
        break;
      case 2:
        val = '2nd Quarter';
        break;
      case 3:
        val = '3rd Quarter';
        break;
      case 4:
        val = '4th Quarter';
        break;
      default:
        val = '';
        break;
    }
    return val;
  };

  const yearOptions = years.map((year) => ({
    label: year,
    value: year,
  }));

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      period: 4,
    };
    fetchRecord(id, args, (data) => {
      setAccountData(_.get(data, 'res.data'));
    });
  };

  const handleSync = (e) => {
    e.preventDefault();
    const args = {
      bin: _.get(formData, 'bin'),
      year: _.get(formData, 'year'),
      period: 4,
    };

    approveTransaction(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    setFormData(c.FORM_DATA);
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {!accountData ? (
          <div className="row">
            <div className="col-12 form-group">
              <label className="form-label">BIN:</label>
              <InputMask
                placeholder="___-__-____-_______"
                className="form-control"
                maskChar=" "
                mask="999-99-9999-9999999"
                autoComplete="none"
                id="bin"
                name="bin"
                onChange={handleOnChange}
                value={_.get(formData, 'bin') || ''}
              />
            </div>
            <div className="col-12 form-group">
              {createSelect(
                {
                  required: true,
                  placeholder: 'Year',
                  key: 'year',
                  label: 'Year:',
                },
                yearOptions
              )}
            </div>
            <div className="col-12 form-group">
              <label className="form-label">Period:</label>
              <InputMask
                readOnly
                className="form-control"
                maskChar=" "
                autoComplete="none"
                id="period"
                name="period"
                onChange={handleOnChange}
                value="4th Quarter"
              />
              {/* {createSelect(
                {
                  required: true,
                  placeholder: 'Period',
                  key: 'period',
                  label: 'Period:',
                },
                c.PERIOD_OPTIONS
              )} */}
            </div>
          </div>
        ) : (
          <table className="table tabl-sm table-striped table-sm mb-0 border-bottom">
            <tbody>
              <tr>
                <td>AMOUNT</td>
                <td>:</td>
                <td>
                  <b>
                    {_.get(accountData, 'amount')
                      ? parseFloat(_.get(accountData, 'amount')).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )
                      : '0.00'}
                  </b>
                </td>
              </tr>
              <tr>
                <td style={{ width: 150 }}>ACCOUNT NAME</td>
                <td>:</td>
                <td>
                  <b>{_.get(accountData, 'account_name') || '---'}</b>
                </td>
              </tr>
              <tr>
                <td>FROM</td>
                <td>:</td>
                <td>
                  <b>{formatPeriod(_.get(accountData, 'qtr_from'))}</b>
                </td>
              </tr>
              <tr>
                <td>TO</td>
                <td>:</td>
                <td>
                  <b>{formatPeriod(_.get(accountData, 'qtr_to'))}</b>
                </td>
              </tr>
              <tr>
                <td>DATE PROCESSED</td>
                <td>:</td>
                <td>
                  <b>
                    {_.get(accountData, 'date_processed')
                      ? moment(
                          `${_.get(accountData, 'date_processed')}`
                        ).format('MMM DD, YYYY')
                      : '---'}
                  </b>
                </td>
              </tr>
              <tr>
                <td>EXPIRATION DATE</td>
                <td>:</td>
                <td>
                  <b>
                    {_.get(accountData, 'expiration_date')
                      ? moment(
                          `${_.get(accountData, 'expiration_date')}`
                        ).format('MMM DD, YYYY')
                      : '---'}
                  </b>
                </td>
              </tr>
            </tbody>
          </table>
        )}

        <div className="d-flex justify-content-center">
          {!accountData ? (
            <button
              disabled={fetching}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
            >
              <span className="font-weight-bold">Submit</span>
            </button>
          ) : (
            <button
              disabled={syncing}
              onClick={handleSync}
              type="button"
              className="mt-3 btn btn-primary cms-bg-color-primary mr-3"
            >
              Confirm
            </button>
          )}
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

FetchModal.propTypes = {
  fetching: PropTypes.bool.isRequired,
  syncing: PropTypes.bool.isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  fetchRecord: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  fetching: _.get(api, 'loading', []).indexOf(c.FETCH_RECORD) > -1,
  syncing: _.get(api, 'loading', []).indexOf(c.SYNC_RECORD) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(FetchModal);
